import { resolve } from '../../../../../init/store';

export class Controller {

    /** @ngInject */
    constructor(Alert, SharedAccountsService) {
        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
    }

    $onInit() {
        this.account = {
            algorithm: 'SHA1',
            digits: 6,
            showOtpEnabled: false,
            showPasswordEnabled: false,
        };
    }

    save() {
        this.isSaving = true;
        this.SharedAccountsService.createCompanyServiceAccounts(
            {
                companyId: resolve.companyId,
                publicServiceId: this.account.publicService.id,
            },
            {
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: true,
                showOtpEnabled: this.account.showOtpEnabled,
                showPasswordEnabled: this.account.showPasswordEnabled,
                publicServiceKey: generatePublicServiceKey(
                    this.account.publicService.serviceName,
                    this.account.username,
                    this.account.secret,
                    this.account.digits,
                    this.account.algorithm,
                ),
            }
        )
            .$promise
            .then(account => {
                this.close({$value: account});
                this.Alert('success', 'company.sharing-center.add.added');
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || !this.account.publicService;
    }

    selectCustom() {
        this.searchItem = 'Custom';
        this.account.publicService = this.resolve.publicServices.find(i => i.slug === "other");
    }
}

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    const secret = secretKey.replace(/\s/g, '');
    return `otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}&digits=${digits}&algorithm=${algorithm}`;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/add/add-shared-authenticator.controller.js